/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UrlShortenerRequest } from '../models/UrlShortenerRequest';
import type { UrlShortenerResource } from '../models/UrlShortenerResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UrlShortenerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Suivre un lien court
     * Redirige (302) vers l'URL cible du `slug` et compte l'ouverture. 404 si le slug est inconnu. C'est l'URL envoyee par SMS aux clients.
     * @param slug
     * @returns string
     * @throws ApiError
     */
    public urlShortenerRedirect(
        slug: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/{slug}',
            path: {
                'slug': slug,
            },
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * Lister les liens courts
     * Tous les liens, avec le nombre d'ouvertures de chacun.
     * @returns UrlShortenerResource Array of `UrlShortenerResource`
     * @throws ApiError
     */
    public shortenerIndex(): CancelablePromise<Array<UrlShortenerResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/shortener',
        });
    }
    /**
     * Creer un lien court
     * Pour `to_url`, optionnellement rattache a une entreprise (`customer_id`, 422 si inconnue). Si un lien existe deja vers cette URL, il est renvoye au lieu d'en creer un second. Le slug fait 5 caracteres.
     * @param requestBody
     * @returns any Array of `UrlShortenerResource`
     * @throws ApiError
     */
    public shortenerStore(
        requestBody?: UrlShortenerRequest,
    ): CancelablePromise<(Array<UrlShortenerResource> | UrlShortenerResource)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/shortener',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un lien court
     * 404 s'il n'existe pas.
     * @param id
     * @returns UrlShortenerResource `UrlShortenerResource`
     * @throws ApiError
     */
    public shortenerShow(
        id: string,
    ): CancelablePromise<UrlShortenerResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/shortener/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Modifier un lien court
     * Change la cible `to_url` et l'entreprise `customer_id`. Le slug ne change pas. 404 s'il n'existe pas.
     * @param id
     * @param requestBody
     * @returns UrlShortenerResource `UrlShortenerResource`
     * @throws ApiError
     */
    public shortenerUpdate(
        id: string,
        requestBody?: UrlShortenerRequest,
    ): CancelablePromise<UrlShortenerResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/shortener/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un lien court
     * Renvoie le lien supprime ; 404 s'il n'existe pas.
     * @param id
     * @returns UrlShortenerResource `UrlShortenerResource`
     * @throws ApiError
     */
    public shortenerDestroy(
        id: string,
    ): CancelablePromise<UrlShortenerResource> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/shortener/{id}',
            path: {
                'id': id,
            },
        });
    }
}
